export enum MatrixType {
  order = 'order',
  preorder = 'preorder',
  availability = 'availability',
  return = 'return',
  warranty = 'warranty',
  swap = 'swap',
  lastSeason = 'last-season',
}
